import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

import HeroBanner from "./HeroBanner/HeroBanner";
import OurJourney from "./OurJourney/OurJourney";
import OurTeam from "./OurTeam/OurTeam";
import Spotlight from "./Spotlight/Spotlight";

import { AboutPageWrapper } from "./index.styles";
import HeroContent from "./HeroContent/HeroContent";

gsap.registerPlugin(ScrollTrigger);

const AboutUs = ({
  heroContent,
  heroBanner,
  ourJourney,
  spotLight,
  ourTeam,
}: any) => {
  const contentRef1 = useRef<any>();
  const contentRef2 = useRef<any>();
  const contentRef3 = useRef<any>();

  useEffect(() => {
    ScrollTrigger.matchMedia({
      "(min-width: 769px)": function () {
        gsap.from(contentRef1.current, {
          scrollTrigger: {
            trigger: contentRef1.current,
            start: "top 80%",
            end: "center 50%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: () => {
              gsap.to(contentRef1.current, {
                scrollTrigger: {
                  trigger: contentRef1.current,
                  start: "top 20%",
                  end: "top top",
                  pinSpacing: false,
                  toggleActions: "restart resume none reverse",
                  scrub: true,
                },
                opacity: 0,
                duration: 1,
              });
            },
          },
          opacity: 0,
          duration: 0.3,
        });
        gsap.from(contentRef2.current, {
          scrollTrigger: {
            trigger: contentRef2.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: () => {
              gsap.to(contentRef2.current, {
                scrollTrigger: {
                  trigger: contentRef2.current,
                  start: "top 20%",
                  end: "top top",
                  pinSpacing: false,
                  toggleActions: "restart resume none reverse",
                  scrub: true,
                },
                opacity: 0,
                duration: 1,
              });
            },
          },
          opacity: 0,
          duration: 0.3,
        });
        gsap.from(contentRef3.current, {
          scrollTrigger: {
            trigger: contentRef3.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
          },
          opacity: 0,
          duration: 0.3,
        });
      },
      "(max-width: 767px)": function () {
        gsap.from(contentRef1.current, {
          scrollTrigger: {
            trigger: contentRef1.current,
            start: "top bottom",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: () => {
              gsap.to(contentRef1.current, { opacity: 0, duration: 1 });
            },
          },
          opacity: 0,
          duration: 0.3,
        });
        gsap.from(contentRef2.current, {
          scrollTrigger: {
            trigger: contentRef2.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: () => {
              gsap.to(contentRef2.current, { opacity: 0, duration: 1 });
            },
          },
          opacity: 0,
          duration: 0.3,
        });
        gsap.from(contentRef3.current, {
          scrollTrigger: {
            trigger: contentRef3.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
          },
          opacity: 0,
          duration: 0.3,
        });
      },
    });
  }, []);

  return (
    <AboutPageWrapper id="aboutUsWrapper">
      <HeroBanner
        title={heroBanner.title}
        src={heroBanner.src}
        alt={heroBanner.alt}
        heroVideo={heroBanner.heroVideo}
      />
      <HeroContent content={heroContent[0]} contentRef={contentRef1} />
      <HeroContent content={heroContent[1]} contentRef={contentRef2} />
      <HeroContent content={heroContent[2]} contentRef={contentRef3} />
      <OurJourney
        heading={ourJourney.heading}
        subHeading={ourJourney.subHeading}
        arrowSrc={ourJourney.arrowSrc}
        arrowAlt={ourJourney.arrowAlt}
        journeyData={ourJourney.journeyData}
        pinIconSrc={ourJourney.pinIconSrc}
      />
      <Spotlight
        title={spotLight.title}
        subTitle={spotLight.subTitle}
        spotLightNews={spotLight.spotLightNews}
        footerArrow={spotLight.footerArrow}
      />
      <OurTeam
        title={ourTeam.title}
        subTitle={ourTeam.subTitle}
        joinUsInfo={ourTeam.joinUs}
        opportunities={ourTeam.opportunities}
      />
    </AboutPageWrapper>
  );
};

export default AboutUs;
